import { createContext } from 'react';
import PaymentsOnHoldSummaryModel from '../../../_shared/models/PaymentOnHoldSummary';

export const paymentsOnHoldContextInitialState = {
  metadata: {
    filterDefinitions: {
      displayName: 'Filters',
      inputs: []
    },
    sortDefinitions: {
      displayName: 'Sorted',
      inputs: []
    }
  },
  summary: new PaymentsOnHoldSummaryModel(),
  trades: {},
  sortSelected: 0,
  filterSelected: 0,
  currentPage: 1,
  tradesOnPage: 50,
  onSortTrades: () => {},
  onFilterTrades: () => {},
  onClickNextPage: () => {},
  onClickPrevPage: () => {},
  onEtrSubmitDocuments: () => {}
};

const PaymentsOnHoldContext = createContext(paymentsOnHoldContextInitialState);

export default PaymentsOnHoldContext;
